import gql from 'graphql-tag';

export default gql`
  mutation removeByIdLessonMutation($_id: MongoID!) {
    removeByIdLessonMutation(_id: $_id) {
      record {
        _id
      }
    }
  }
`;
